import type { Team } from './enums.js';

export const ROUNDS_TO_WIN = 13;
export const OVERTIME_THRESHOLD = ROUNDS_TO_WIN - 1;

export type ScoreValidationResult = { valid: true; winner: Team } | { valid: false; error: string };

/**
 * Valorant score rules:
 *  - regulation: winner has exactly 13, loser ≤ 11
 *  - overtime (12:12 reached): winner leads by exactly 2, e.g. 14:12, 15:13
 */
export function validateMapScore(scoreA: number, scoreB: number): ScoreValidationResult {
  if (!Number.isInteger(scoreA) || !Number.isInteger(scoreB) || scoreA < 0 || scoreB < 0) {
    return { valid: false, error: 'Scores müssen ganze Zahlen ≥ 0 sein.' };
  }
  if (scoreA === scoreB) {
    return { valid: false, error: 'Unentschieden ist nicht möglich.' };
  }
  const winner: Team = scoreA > scoreB ? 'a' : 'b';
  const high = Math.max(scoreA, scoreB);
  const low = Math.min(scoreA, scoreB);

  if (high < ROUNDS_TO_WIN) {
    return { valid: false, error: `Der Gewinner braucht mindestens ${ROUNDS_TO_WIN} Runden.` };
  }
  if (low < OVERTIME_THRESHOLD) {
    if (high !== ROUNDS_TO_WIN) {
      return {
        valid: false,
        error: `Ohne Overtime endet die Map bei genau ${ROUNDS_TO_WIN} Runden.`,
      };
    }
    return { valid: true, winner };
  }
  if (high - low !== 2) {
    return {
      valid: false,
      error: 'In der Overtime gewinnt ein Team mit genau 2 Runden Vorsprung.',
    };
  }
  return { valid: true, winner };
}
